/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Confirm_Cancel_Schedule_TitleInputs */



/**
* | output |
* | --- |
* | "Cancel scheduled change" |
*
* @param {Sub_Addons_Confirm_Cancel_Schedule_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_cancel_schedule_title = /** @type {((inputs?: Sub_Addons_Confirm_Cancel_Schedule_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Cancel_Schedule_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geplante Änderung abbrechen")
	return /** @type {LocalizedString} */ ("Cancel scheduled change")
});